import { CrmSyncStatus, MeetingStatus } from '@alucio/aws-beacon-amplify/src/models';
import { MeetingORM } from 'src/types/types';
import { DNAChipBeaconVariant } from 'src/components/DNA/Chip/variants';

interface CrmDisplayInfo {
  variant: DNAChipBeaconVariant;
  showSyncButton: boolean;
}

const STATUS_MAP: Record<string, CrmDisplayInfo> = {
  NOT_SYNCED: {
    variant: 'CRM_STATUS_NOT_SYNCED',
    showSyncButton: true,
  },
  SAVED_TO_CRM: {
    variant: 'CRM_STATUS_SAVED',
    showSyncButton: false,
  },
  SUBMITTED: {
    variant: 'CRM_STATUS_SUBMITTED',
    showSyncButton: false,
  },
};

export const getCrmDisplayStatus = (meetingORM: MeetingORM): CrmDisplayInfo => {
  const { status, crmRecord } = meetingORM.model;

  if (status === MeetingStatus.LOCKED) {
    return STATUS_MAP.SUBMITTED;
  }

  if (crmRecord?.crmSyncStatus === CrmSyncStatus.SYNCED) {
    return STATUS_MAP.SAVED_TO_CRM;
  }

  // RECORDS DELETED IN CRM SHOULDN'T SURFACE A "SYNC NOW" CTA
  if (crmRecord?.crmSyncStatus === CrmSyncStatus.DELETED) {
    return { ...STATUS_MAP.NOT_SYNCED, showSyncButton: false };
  }

  return STATUS_MAP.NOT_SYNCED;
};
